var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ locked: _vm.locked },attrs:{"scroll-menu":""}},[_c('Slider',{attrs:{"usePlain":"","slides-per-view":"auto","breakpoints":{768:{allowTouchMove: false}},"watch-overflow":""},on:{"initialized":_vm.init}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }